require("../../scss/modular.scss");
import ScrollReveal from 'scrollreveal';

var modular = function(){

	var sections, getHash, setHash, getVisibleArticleId, navNext, initHash;

	constructor = function(){

		//get all sections
		sections = [];
		$("article").each(function(index, item){
			sections[$(item).attr("id")] = $(item);
		});

        //equal rows
		$('article .equalRow .equalCol').matchHeight();

		//setup navnext
		$(".navNext").click(function(){
			navNext();
			return false;
		});

        //force hash nav
        if(initHash){
            console.log("hash "+ initHash)
            setTimeout(function(){
                location.hash = "#" + initHash;
            }, 150)
            
        }

		//keep the hash updated
		$(window).scroll(setHash);
		$(window).resize(setHash);
	}

	setHash = function(){
		var hash = APP.getHash();
		var nhash = getVisibleArticleId();
		if(hash == nhash || nhash == "") return;
		APP.setHash(nhash);
	}

	getVisibleArticleId = function(){
		var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
		scrollTop+= APP.getWinVisibleSize().height/2;
		for(var section in sections){
			var top = sections[section].offset().top;
			var bottom = top + sections[section].outerHeight();
			if(scrollTop>top && scrollTop<bottom) return section;
		}
		return "";
	}

	navNext = function(){
		var isTheOne = false;
		for(var section in sections){
			if(isTheOne) break;
			if(APP.getHash() == section) isTheOne =  true;
		}
		APP.scrollToElem("#"+section);
	}

	resizeWin = function(viewportSize){

	}

	var setupMap = function(){
		
		var mapContainer = document.getElementById('mapa');
		if(mapContainer){
			var latlngdata = $(mapContainer).data("latlng");
			latlngdata = String(latlngdata).split(",");
			var myLatLng = {lat: parseFloat(latlngdata[0]), lng: parseFloat(latlngdata[1])};

	        var map = new google.maps.Map(mapContainer, {
	          zoom: 18,
	          center: myLatLng,
    		  mapTypeControl: false,
    		  fullscreenControl: false,
    		  rotateControl: false,
    		  streetViewControl: false,
    		  tilt: 20,
    		  styles: mapStyle
	        });
	        var bounds = new google.maps.LatLngBounds();
	        var myLatLng, marker;
	        for (var i = 0; i < window.dataMap.length; i++) {
                var latlngdata = window.dataMap[i].latlng.split(",");
                myLatLng = {lat: parseFloat(latlngdata[0]), lng: parseFloat(latlngdata[1])};
                bounds.extend(myLatLng);
                marker = new google.maps.Marker({
		          position: myLatLng,
		          map: map,
		          icon: window.markerIcon,
		          title: window.dataMap[i].titulo
		        });
            }
            map.fitBounds(bounds);
        }
	}

	window.initMap = setupMap;
	$(document).ready(constructor);

    initHash = APP.getHash();

	var mapStyle = [
        {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": "-15"
                },
                {
                    "lightness": "0"
                },
                {
                    "gamma": "1"
                },
                {
                    "weight": "1"
                },
                {
                    "hue": "#7373A5"
                }
            ]
        },
        {
            "featureType": "administrative.locality",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "saturation": "-13"
                }
            ]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "landscape.natural.terrain",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#7373A5"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#266b46"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "weight": "1.21"
                }
            ]
        },
        {
            "featureType": "poi.business",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "weight": "0.74"
                },
                {
                    "gamma": "1.00"
                },
                {
                    "lightness": "0"
                },
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "hue": "#7373A5"
                },
                {
                    "saturation": "-42"
                },
                {
                    "lightness": "-17"
                },
                {
                    "gamma": "2.37"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
                {
                    "saturation": -70
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "saturation": "-62"
                },
                {
                    "lightness": "-48"
                },
                {
                    "gamma": "0.00"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
                {
                    "visibility": "simplified"
                },
                {
                    "saturation": -60
                }
            ]
        }
    ];

	return {
		resize: resizeWin
	}
}

modular();